import i18next from "i18next";
import { Card, Col, Row, Button, Tooltip, Space, Select, Form, Input, Spin } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { user_state } from '../../../features/user/userSlice';
import { RoleService } from "../../../service/rolService";
import { CommonService } from "../../../service/common/commonService";
import { ServicesConfig } from "../../../service/servicesConfig";


const URSAdministrationComponent = ({ dataRoles, dataUsers, dataServices }) => {

    const dispatch = useDispatch();
    const userstate = useSelector(user_state);

    const [cargando, setCargando] = useState(undefined)

    const [selectedUser, setSelectedUser] = useState(undefined);
    const [selectedRol, setSelectedRol] = useState(undefined);
    const [selectedService, setSelectedService] = useState(undefined);


    const [inputUserName, setInputUserName] = useState("")
    const [inputUserPassword, setInputUserPassword] = useState("")
    const [selectedUserRol, setSelectedUserRol] = useState(undefined)

    const [inputIDRol, setInputIDRol] = useState("")
    const [inputRolName, setInputRolName] = useState("")

    const [inputIDService, setInputIDService] = useState("")
    const [inputUserService, setInputUserService] = useState("")
    const [inputPasswordService, setInputPasswordService] = useState("")

    const [selectUserOptions, setSelectUserOptions] = useState([]);
    const [selectRolOptions, setSelectRolOptions] = useState([])
    const [selectServiceOptions, setSelectServiceOptions] = useState([])
    const [selectUserRolOptions, setSelectUserRolOptions] = useState([])



    const [datosUsers, setDataUsers] = useState(dataUsers);
    const [datosRoles, setDataRoles] = useState(dataRoles)
    const [datosServices, setDatosServices] = useState(dataServices)


    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());


    const reset = (e) => {
        if (e == "user") {
            setInputUserName("")
            setInputUserPassword("")
            setSelectedUser(undefined)
        }
        if (e == "rol") {
            setInputIDRol("")
            setInputRolName("")
            setSelectedRol(undefined)
        }
        if (e == "service") {
            setInputIDService("")
            setInputUserService("")
            setInputPasswordService("")
            setSelectedService(undefined)
        }
    }

    const submit = (e) => {
        if (e == "rol") {
            let obj = {
                "idRol": inputIDRol,
                "name": inputRolName,
            }
            //alert("TODO create rol " + JSON.stringify(obj))
            CommonService.post(ServicesConfig.getBaseUrl() + "/sgvmap/admin/rol/create", obj)
        }
        if (e == "user") {
            let obj = {
                "usr": inputUserName,
                "password": inputUserPassword,
                "role": selectedUserRol
            }
            //alert("TODO create user " + JSON.stringify(obj))
            CommonService.post(ServicesConfig.getBaseUrl() + "/sgvmap/admin/user/create", obj)
        }       
    }

    /**
* Función que convierte los datos de los mapas a un formato legible en un select
* 
* @returns 
*/
    const getSelectUsersOptions = () => {
        let dataCopy = [...datosUsers]
        //console.log("copia", dataCopy)
        let arrayOptions = dataCopy.map((dato) => {
            return {
                "value": dato.usr,
                "label": dato.usr
            }
        })
        setSelectUserOptions(arrayOptions)
    }

    /**
 * Función que convierte los datos de los roles a un formato legible en un select
 */
    const getSelectRolOptions = () => {
        let dataCopy = [...datosRoles]
        //console.log("data roles", dataCopy)
        let arrayOpciones = dataCopy.map((dato) => {
            return {
                "value": dato.idRol,
                "label": dato.name
            }
        })
        setSelectRolOptions(arrayOpciones)
    }

    const getSelectServicesOptions = () => {
        let dataCopy = [...datosServices]
        let arrayOpciones = dataCopy.map((dato) => {
            return {
                "value": dato.idSrvSec,
                "label": dato.username
            }
        })
        setSelectServiceOptions(arrayOpciones)
    }

    const onClickModificar = (e) => {
        if (e == "user") {
            asignUserInputs()
        }
        if (e == "rol") {
            asignRolInputs()
        }
        if (e == "service") {
            asignServiceInputs()
        }
    }


    const onClickCrear = (e) => {
        reset(e)
    }


    const onClickBorrar = async (e) => {
        if (e == "rol") {
            let obj = {
                "idRol": selectedRol,
            }
            //alert("TODO delete rol AAA " + JSON.stringify(obj))
            CommonService.post(ServicesConfig.getBaseUrl() + "/sgvmap/admin/rol/delete", obj)
        }
        if (e == "user") {
            let obj = {
                "usr": selectedUser,
            }
            //alert("TODO delete user AAA " + JSON.stringify(obj))
            CommonService.post(ServicesConfig.getBaseUrl() + "/sgvmap/admin/user/delete", obj)
        }
    }


    const asignUserInputs = () => {

        if (selectedUser != undefined) {
            setCargando("user")
            RoleService.getRolUser(selectedUser)
                .then((data) => {

                    let idRol = data.sgvmapRoleList[0].idRol
                    setSelectedUserRol(idRol)
                    let user = datosUsers.find((user) => user.usr == selectedUser)
                    console.log("ussu", user)
                    setInputUserName(user.usr)
                    setInputUserPassword("undefine")
                    setCargando(undefined)
                })
                .catch((error) => {
                    console.log(error)
                    setInputUserName("")
                    setInputUserPassword("")
                    setSelectedUserRol(undefined)
                    setCargando(undefined)
                })
        }
    }

    const asignRolInputs = () => {
        if (selectedRol != undefined) {
            setCargando("rol")
            let rol = datosRoles.find((rol) => rol.idRol == selectedRol)
            console.log("rol", rol)
            setInputIDRol(rol.idRol)
            setInputRolName(rol.name)
            setCargando(undefined)
        }
    }

    const asignServiceInputs = () => {
        if (selectedService != undefined) {
            setCargando("service")
            let service = datosServices.find((service) => service.idSrvSec == selectedService)
            setInputIDService(service.idSrvSec)
            setInputUserService(service.username)
            setInputPasswordService(service.password)
            setCargando(undefined)
        }
    }

    useEffect(() => {
        //console.log("render", getSelectMapOptions())
        //console.log("user", userstate)
        getSelectUsersOptions()
        getSelectRolOptions()
        getSelectServicesOptions()
        //setRolUser()
    }, [])

    useEffect(() => {

    }, [selectedUser])

    return (
        <>
            <Card>
                <Row>
                    <Col span={8} style={{ "borderRight": "1 solid black" }}>
                        <h2>{i18next.t('common.administration.tab_urs.user.name')}</h2>
                        <Row>
                            <Col span={11}>
                                <Space direction="vertical">
                                    <h3>{i18next.t('common.administration.tab_urs.user.header.options')}</h3>
                                    <div>
                                        <Button style={{ "marginRight": "5px", "width": "130px" }} size="large" disabled={selectedUser == undefined ? false : true}
                                            onClick={(e) => onClickCrear("user")}>{i18next.t('common.administration.tools.boton_crear.name')}</Button>
                                        <Tooltip placement="right" title={i18next.t('common.administration.tools.boton_crear.info')}>
                                            {<InfoCircleFilled style={{ fontSize: '16px', color: '#08c' }} />}
                                        </Tooltip>
                                    </div>
                                    <div>
                                        <Button style={{ "marginRight": "5px", "width": "130px" }} size="large" disabled={selectedUser == undefined ? true : false}
                                            onClick={(e) => onClickModificar("user")}>{i18next.t('common.administration.tools.boton_modificar.name')}</Button>
                                        <Tooltip placement="right" title={i18next.t('common.administration.tools.boton_modificar.info')}>
                                            {<InfoCircleFilled style={{ fontSize: '16px', color: '#08c' }} />}
                                        </Tooltip>
                                    </div>
                                    <div>
                                        <Button style={{ "marginRight": "5px", "width": "130px" }} size="large" disabled={selectedUser == undefined ? true : false}
                                            onClick={(e) => onClickBorrar("user")}>{i18next.t('common.administration.tools.boton_borrar.name')}</Button>
                                        <Tooltip placement="right" title={i18next.t('common.administration.tools.boton_borrar.info')}>
                                            {<InfoCircleFilled style={{ fontSize: '16px', color: '#08c' }} />}
                                        </Tooltip>
                                    </div>
                                    <div>
                                        <p>{i18next.t('common.administration.tab_urs.user.fields.select')}</p>
                                        <Select
                                            showSearch
                                            allowClear
                                            placeholder="Select a user"
                                            optionFilterProp="children"
                                            value={selectedUser}
                                            onChange={(e) => setSelectedUser(e)}
                                            filterOption={filterOption}
                                            options={selectUserOptions}
                                        />
                                    </div>
                                    {
                                        cargando == "user" && <div>
                                            <Space>
                                                <Spin /> <p>CARGANDO...</p>
                                            </Space>
                                        </div>
                                    }
                                </Space>
                            </Col>
                            <Col span={11}>
                                <Row>
                                    <Col span={24}>
                                        <h3>{i18next.t('common.administration.tab_urs.user.header.data')}</h3>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24} style={{ "padding": "10px" }}>
                                        <Form
                                            layout={"vertical"}
                                        >
                                            <Form.Item label={i18next.t('common.administration.tab_urs.user.fields.name')}>
                                                <Input placeholder="input placeholder" value={inputUserName} onChange={(e) => setInputUserName(e.target.value)} />
                                            </Form.Item>
                                            <Form.Item label={i18next.t('common.administration.tab_urs.user.fields.password')}>
                                                <Input placeholder="input placeholder" value={inputUserPassword} onChange={(e) => setInputUserPassword(e.target.value)} />
                                            </Form.Item>
                                            <Form.Item label={i18next.t('common.administration.tab_urs.user.fields.role')}>
                                                <Select
                                                    showSearch
                                                    allowClear
                                                    placeholder="Select a user rol"
                                                    optionFilterProp="children"
                                                    value={selectedUserRol}
                                                    onChange={(e) => setSelectedUserRol(e)}
                                                    filterOption={filterOption}
                                                    options={selectRolOptions}
                                                />
                                            </Form.Item>
                                        </Form>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} style={{ "textAlign": "center", "marginTop": "15px" }}>
                                <Space>
                                    <Button size="large" onClick={() => submit("user")}>{i18next.t('common.administration.tools.boton_guardar.name')}</Button>
                                    <Button size="large" onClick={() => reset("user")}>{i18next.t('common.administration.tools.boton_cancelar.name')}</Button>
                                </Space>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={8}>
                        <h2>{i18next.t('common.administration.tab_urs.role.name')}</h2>
                        <Row>
                            <Col span={11}>
                                <Space direction="vertical">
                                    <h3>{i18next.t('common.administration.tab_urs.role.header.options')}</h3>
                                    <div>
                                        <Button style={{ "marginRight": "5px", "width": "130px" }} size="large" disabled={selectedRol == undefined ? false : true}
                                            onClick={(e) => onClickCrear("rol")}>{i18next.t('common.administration.tools.boton_crear.name')}</Button>
                                        <Tooltip placement="right" title={i18next.t('common.administration.tools.boton_crear.info')}>
                                            {<InfoCircleFilled style={{ fontSize: '16px', color: '#08c' }} />}
                                        </Tooltip>
                                    </div>
                                    <div>
                                        <Button style={{ "marginRight": "5px", "width": "130px" }} size="large" disabled={selectedRol == undefined ? true : false}
                                            onClick={(e) => onClickModificar("rol")}>{i18next.t('common.administration.tools.boton_modificar.name')}</Button>
                                        <Tooltip placement="right" title={i18next.t('common.administration.tools.boton_modificar.info')}>
                                            {<InfoCircleFilled style={{ fontSize: '16px', color: '#08c' }} />}
                                        </Tooltip>
                                    </div>
                                    <div>
                                        <Button style={{ "marginRight": "5px", "width": "130px" }} size="large" disabled={selectedRol == undefined ? true : false}
                                            onClick={(e) => onClickBorrar("rol")}>{i18next.t('common.administration.tools.boton_borrar.name')}</Button>
                                        <Tooltip placement="right" title={i18next.t('common.administration.tools.boton_borrar.info')}>
                                            {<InfoCircleFilled style={{ fontSize: '16px', color: '#08c' }} />}
                                        </Tooltip>
                                    </div>
                                    <div>
                                        <p>{i18next.t('common.administration.tab_urs.role.fields.select')}</p>
                                        <Select
                                            showSearch
                                            allowClear
                                            placeholder="Select a rol"
                                            optionFilterProp="children"
                                            value={selectedRol}
                                            onChange={(e) => setSelectedRol(e)}
                                            filterOption={filterOption}
                                            options={selectRolOptions}
                                        />
                                    </div>
                                    {
                                        cargando == "rol" && <div>
                                            <Space>
                                                <Spin /> <p>CARGANDO...</p>
                                            </Space>
                                        </div>
                                    }
                                </Space>
                            </Col>
                            <Col span={11}>
                                <Row>
                                    <Col span={24}>
                                        <h3>{i18next.t('common.administration.tab_urs.role.header.data')}</h3>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24} style={{ "padding": "10px" }}>
                                        <Form
                                            layout={"vertical"}
                                        >
                                            <Form.Item label={i18next.t('common.administration.tab_urs.role.fields.id')}>
                                                <Input placeholder="input placeholder" value={inputIDRol} onChange={(e) => setInputIDRol(e.target.value)} />
                                            </Form.Item>
                                            <Form.Item label={i18next.t('common.administration.tab_urs.role.fields.name')}>
                                                <Input placeholder="input placeholder" value={inputRolName} onChange={(e) => setInputRolName(e.target.value)} />
                                            </Form.Item>
                                        </Form>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} style={{ "textAlign": "center", "marginTop": "60px" }}>
                                <Space>
                                    <Button size="large" onClick={() => submit("rol")}>{i18next.t('common.administration.tools.boton_guardar.name')}</Button>
                                    <Button size="large" onClick={() => reset("rol")}>{i18next.t('common.administration.tools.boton_cancelar.name')}</Button>
                                </Space>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={8}>
                        <h2>{i18next.t('common.administration.tab_urs.service.name')}</h2>
                        <Row>
                            <Col span={11}>
                                <Space direction="vertical">
                                    <h3>{i18next.t('common.administration.tab_urs.service.header.options')}</h3>
                                    <div>
                                        <Button style={{ "marginRight": "5px", "width": "130px" }} size="large" disabled={selectedService == undefined ? false : true}
                                            onClick={(e) => onClickCrear("service")}>{i18next.t('common.administration.tools.boton_crear.name')}</Button>
                                        <Tooltip placement="right" title={i18next.t('common.administration.tools.boton_crear.info')}>
                                            {<InfoCircleFilled style={{ fontSize: '16px', color: '#08c' }} />}
                                        </Tooltip>
                                    </div>
                                    <div>
                                        <Button style={{ "marginRight": "5px", "width": "130px" }} size="large" disabled={selectedService == undefined ? true : false}
                                            onClick={(e) => onClickModificar("service")}>{i18next.t('common.administration.tools.boton_modificar.name')}</Button>
                                        <Tooltip placement="right" title={i18next.t('common.administration.tools.boton_modificar.info')}>
                                            {<InfoCircleFilled style={{ fontSize: '16px', color: '#08c' }} />}
                                        </Tooltip>
                                    </div>
                                    <div>
                                        <Button style={{ "marginRight": "5px", "width": "130px" }} size="large" disabled={selectedService == undefined ? true : false}
                                            onClick={(e) => onClickBorrar("service")}>{i18next.t('common.administration.tools.boton_borrar.name')}</Button>
                                        <Tooltip placement="right" title={i18next.t('common.administration.tools.boton_borrar.info')}>
                                            {<InfoCircleFilled style={{ fontSize: '16px', color: '#08c' }} />}
                                        </Tooltip>
                                    </div>
                                    <div>
                                        <p>{i18next.t('common.administration.tab_urs.service.fields.select')}</p>
                                        <Select
                                            showSearch
                                            allowClear
                                            placeholder="Select a service"
                                            optionFilterProp="children"
                                            value={selectedService}
                                            onChange={(e) => setSelectedService(e)}
                                            filterOption={filterOption}
                                            options={selectServiceOptions}
                                        />
                                    </div>
                                    {
                                        cargando == "service" && <div>
                                            <Space>
                                                <Spin /> <p>CARGANDO...</p>
                                            </Space>
                                        </div>
                                    }
                                </Space>
                            </Col>
                            <Col span={11}>
                                <Row>
                                    <Col span={24}>
                                        <h3>{i18next.t('common.administration.tab_urs.service.header.data')}</h3>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24} style={{ "padding": "10px" }}>
                                        <Form
                                            layout={"vertical"}
                                        >
                                            <Form.Item label={i18next.t('common.administration.tab_urs.service.fields.id')}>
                                                <Input placeholder="input placeholder" value={inputIDService} onChange={(e) => setInputIDService(e.target.value)} />
                                            </Form.Item>
                                            <Form.Item label={i18next.t('common.administration.tab_urs.service.fields.user')}>
                                                <Input placeholder="input placeholder" value={inputUserService} onChange={(e) => setInputUserService(e.target.value)} />
                                            </Form.Item>
                                            <Form.Item label={i18next.t('common.administration.tab_urs.service.fields.password')}>
                                                <Input placeholder="input placeholder" value={inputPasswordService} onChange={(e) => setInputPasswordService(e.target.value)} />
                                            </Form.Item>
                                        </Form>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} style={{ "textAlign": "center", "marginTop": "15px" }}>
                                <Space>
                                    <Button size="large" onClick={() => submit("service")}>{i18next.t('common.administration.tools.boton_guardar.name')}</Button>
                                    <Button size="large" onClick={() => reset("service")}>{i18next.t('common.administration.tools.boton_cancelar.name')}</Button>
                                </Space>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Card>
        </>
    );

}

export default URSAdministrationComponent;